import { ChallengeFormType, FormValidator } from '../../NewChallengeForm.types';

export const validate: FormValidator<
  Pick<ChallengeFormType, 'isRegisterDepositFixed'>
> = () => {
  return { isValid: true };
};
